import { CommonFileModel } from "models/CommonFileModel";
import React from "react";

type PROPS = {
  data?: CommonFileModel;
  width?: string;
  minWidth?: string;
  height?: string;
  maxHeight?: string;
  minHeight?: string;
  show_file_name?: boolean;
  default?: string;
};

const Image: React.FC<PROPS> = (props) => {
  const data = props.data ?? { file_name: "", file_data: "", image_url: "" };

  React.useEffect(() => {}, [props.data]);

  let src = "";
  if (data.file_data) {
    src = data.file_data;
  } else if (data.image_url) {
    src = data.image_url;
  } else if (data.image_data) {
    src = data.image_data;
  }

  if (!src && props.default) {
    src = `${process.env.PUBLIC_URL}/images/${props.default}`;
  }

  const style: React.CSSProperties = {};
  if (props.width) {
    style.width = props.width;
  }
  if (props.minWidth) {
    style.minWidth = props.minWidth;
  }
  if (props.height) {
    style.height = props.height;
  }
  if (props.maxHeight) {
    style.maxHeight = props.maxHeight;
  } else {
    style.maxHeight = "250px";
  }
  if (props.minHeight) {
    style.minHeight = props.minHeight;
  } else if (!props.height && !props.maxHeight) {
    style.minHeight = "150px";
  }

  return (
    <div className="flex flex-col">
      {src ? (
        <img src={src} alt="" className="object-contain" style={style} />
      ) : (
        <div className="" style={style}></div>
      )}
      {props.show_file_name && (
        <div className={`text-right text-sm overflow-hidden text-ellipsis ${props.data?.is_new ? 'text-red-500' : 'text-gray-400'}`}>
          {data.file_name}
        </div>
      )}
    </div>
  );
};

export default Image;
